import { observer } from 'mobx-react-lite';
import { FC, PropsWithChildren } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { usePrivateDomainPresenter } from './PrivateDomain.presenter';

interface IPrivateDomain {
  redirectTo: string;
}

export const PrivateDomain: FC<PropsWithChildren<IPrivateDomain>> = observer(
  ({ redirectTo, children }) => {
    const presenter = usePrivateDomainPresenter();
    const location = useLocation();

    if (presenter.isShowSkeleton) {
      return null;
    }

    if (!presenter.isAllowedPrivateContent) {
      return (
        <Navigate
          to={{
            pathname: redirectTo,
            search: location.search,
          }}
          replace
        />
      );
    }

    return <>{children}</>;
  }
);
